import React from 'react';
import { connect } from 'react-redux'
import formatDate from '../Classes/FormatDate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GetPOAndLineItemListForDispatch, GetPOAndLineItemListForDispatchForDCListing } from '../store/actions/dispatchOrderDetailsActions';
import { GetGRNDetails, GetGRNExport } from '../store/actions/poDetailsActions';
import { GetAllInvoicesForSupplier, } from '../store/actions/invoiceActions';
import { getBGListDetails } from '../store/actions/expediting.Actions'
import { getInspectionDetailsByInspectorID } from '../store/actions/inspectionActions'
import AuthHandlerInstance from '../Classes/AuthHandler'
import { Button, Table, InputGroup, Form, FormControl, Card, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Select, { components } from "react-select"
import Image from 'react-bootstrap/Image'
import numberWithCommas from '../Classes/NumberwithComma'
import AuthHandler from '../Classes/AuthHandler';
import authInstance from '../Classes/AuthHandler';
import SearchBar from '../Components/SearchBar'
import { GetFilterList } from '../store/actions/masterActions'
import BootstrapTable from 'react-bootstrap-table-next';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { GetExcellExportData, getPOSearch } from '../store/actions/poDetailsActions';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import dateFormater from '../Classes/FormatDate';
import timeFormater from '../Classes/FormatDateTimeInIST'
import { faDownload } from '@fortawesome/free-solid-svg-icons';
function formatedDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('.');
}
class ReportExtraction extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            checkedAll: false,
            isShowFilter: false,
            forModule: [],
            finalvendorlist: [],
            tabledata: [],
            finalinspectorlist: [],
            filterByPOSAPId: [],
            filterByVendorName: [],
            sortByVendor: [],
            projectNo: "",
            array: [
                { value: 1, label: "element1" },
                { value: 2, label: "element2" },
                { value: 3, label: "element3" },
                { value: 4, label: "element4" }],
            searchTerm: new URLSearchParams(this.props.location.search).get("searchTerm") ? new URLSearchParams(this.props.location.search).get("searchTerm") : "",
            isShowFilter: false,
            sortByWBS: new URLSearchParams(this.props.location.search).get("sortByWBS") ? (new URLSearchParams(this.props.location.search).get("sortByWBS")).split(',') : [],
            sortByPlantCode: new URLSearchParams(this.props.location.search).get("sortByPlantCode") ? (new URLSearchParams(this.props.location.search).get("sortByPlantCode")).split(',') : [],
            sortByEmployees: new URLSearchParams(this.props.location.search).get("sortByEmployees") ? (new URLSearchParams(this.props.location.search).get("sortByEmployees")).split(',') : [],
            sortByPo: new URLSearchParams(this.props.location.search).get("sortByPo") ? (new URLSearchParams(this.props.location.search).get("sortByPo")).split(',') : [],
            poDocStartDate: new URLSearchParams(this.props.location.search).get("poDocStartDate") ? new URLSearchParams(this.props.location.search).get("poDocStartDate") : "",
            poDocEndDate: new URLSearchParams(this.props.location.search).get("poDocEndDate") ? new URLSearchParams(this.props.location.search).get("poDocEndDate") : "",
            sortByVendor: new URLSearchParams(this.props.location.search).get("sortByPo") ? (new URLSearchParams(this.props.location.search).get("sortByVendor")).split(',') : [],
            vendor: new URLSearchParams(this.props.location.search).get("vendor") ? new URLSearchParams(this.props.location.search).get("vendor") : "",
            inspectionLocation: new URLSearchParams(this.props.location.search).get("inspectionLocation") ? new URLSearchParams(this.props.location.search).get("inspectionLocation") : "",
            status: new URLSearchParams(this.props.location.search).get("status") ? new URLSearchParams(this.props.location.search).get("status") : "",
            searchForItem: [],
            searchForOptions: [
                { label: 'Planner', value: 'Planner' },
                { label: 'PO Number', value: 'PO Number' },
                { label: 'Vendor', value: 'Vendor' },
                { label: 'WBS', value: 'WBS' },
            ],
            searchFor: new URLSearchParams(this.props.location.search).get("searchFor") ? new URLSearchParams(this.props.location.search).get("searchFor") : "",
            csvData: [],
            csvItem: [],
            columns: [],
            loading: false,
            invoiceTableData: [],
            currentPage: new URLSearchParams(this.props.location.search).get("currentPage") ? new URLSearchParams(this.props.location.search).get("currentPage") : 1,
            totalPos: 0,
            posPerpage: new URLSearchParams(this.props.location.search).get("posPerpage") ? new URLSearchParams(this.props.location.search).get("posPerpage") : 10,
        }
    }

    componentDidMount = async () => {
        await this.getFilterList()
        console.log(this.props)
    }

    getFilterList = async () => {
        await this.props.GetFilterList()
        console.log(this.props.filterList, 'filterList')

        let finalvendorlist = []
        let finalpos = []
        let finalwbsno = []
        let finalplantcode = []
        let finalemployees = []
        await finalemployees.push({ label: `Open`, value: 'opened' })
        await this.props.filterList[5].map(async (item) => {
            await finalemployees.push({ label: `${item.EmployeeName}`, value: item.EmployeeName })
        })
        await this.props.filterList[3].map(async (item) => {
            await finalvendorlist.push({ label: item.VendorName, value: item.VendorName })
        })
        await this.props.filterList[4].map(async (item) => {
            await finalpos.push({ label: item.POSAPId, value: item.POSAPId })
        })
        await this.props.filterList[1].map(async (item) => {
            await finalplantcode.push({ label: item.PlantCode, value: item.PlantCode })
        })
        await this.props.filterList[2].map(async (item) => {
            await finalwbsno.push({ label: item.WBSCode, value: item.WBSCode })
        })
        await this.state.sortByWBS.map(async (item) => {
            await WBSCode.push({ label: item, value: item })
        })
        let POSAPId = []
        let WBSCode = []
        let PlantCode = []
        let VendorName = []
        let employees = []
        let searchForItem = []
        await this.state.sortByPo.map(async (item) => {
            await POSAPId.push({ label: item, value: item })
        })
        await this.state.sortByVendor.map(async (item) => {
            await VendorName.push({ label: item, value: item })
        })
        await this.state.sortByEmployees.map(async (item) => {
            await employees.push({ label: item, value: item })
        })
        await this.state.sortByPlantCode.map(async (item) => {
            await PlantCode.push({ label: item, value: item })
        })
        await this.setState({ finalvendorlist, finalpos, finalwbsno, finalplantcode, finalemployees, PlantCode, WBSCode, POSAPId, VendorName, employees })
    }

    handleSelectEmployees = async (e) => {
        let sortByEmployees = []
        let sortBy = 'all'
        let employees = []
        console.log("planner is ---------->", e)
        if (e.length > 0) {
            e.map((item) => {
                if (item.value !== 'opened') {
                    sortByEmployees.push(item.value)
                } else {
                    sortBy = 'opened'
                }
                employees.push(item)
            })
        }
        await this.setState({ sortByEmployees, employees, sortBy })
    }

    handleSelectVendor = async (e) => {
        let sortByVendor = []
        let VendorName = []
        console.log(e, "HHHH")
        if (e.length > 0) {
            e.map((item) => {
                sortByVendor.push(item.value)
                VendorName.push(item)
            })
        }
        await this.setState({ sortByVendor, VendorName })
    }

    handleSelectPO = async (e) => {
        let sortByPo = []
        let POSAPId = []
        if (e.length > 0) {
            e.map((item) => {
                sortByPo.push(item.value)
                POSAPId.push(item)
            })
        }
        await this.setState({ sortByPo, POSAPId })
    }
    handleSelectPlantCode = async (e) => {
        let sortByPlantCode = []
        let PlantCode = []
        if (e.length > 0) {
            e.map((item) => {
                sortByPlantCode.push(item.value)
                PlantCode.push(item)
            })
        }
        await this.setState({ sortByPlantCode, PlantCode })

    }
    handleSelectWBS = async (e) => {
        let sortByWBS = []
        let WBSCode = []
        if (e.length > 0) {
            e.map((item) => {
                sortByWBS.push(item.value)
                WBSCode.push(item)
            })
        }
        await this.setState({ sortByWBS, WBSCode })
    }
    consoledata = async () => {
        this.setState({ loading: true })
        let input = {
            VendorName: this.state.VendorName,
            PlantCode: this.state.PlantCode,
            POSAPId: this.state.POSAPId,
            WBSCode: this.state.WBSCode,
            forModule: this.state.forModule,
        }
        let csvData = []
        let columns = []
        console.log("props is excel-------------->", this.props.poDetails.excelData)
        if (this.state.forModule.value === 'Purchase Orders') {
            await this.props.GetExcellExportData()
            columns.push(
                {
                    dataField: 'Id', text: 'Id', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '50px', textAlign: 'center' };
                    }, hidden: true,
                },
                {
                    dataField: 'POSAPId', text: 'POSAPId', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter(),
                },
                {
                    dataField: 'ProjectCode', text: 'ProjectCode', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter(),
                },
                {
                    dataField: 'PlantCode', text: 'PlantCode', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter(),
                },
                {
                    dataField: 'PurchaseGroup', text: 'PurchaseGroup', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter(),
                },
                {
                    dataField: 'VendorSapId', text: 'VendorSapId', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter(),
                },
                {
                    dataField: 'VendorName', text: 'Vendor Name', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter(),
                },
                {
                    dataField: 'PaymentTermCode', text: 'Payment Term Code', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter(),
                },
                {
                    dataField: 'Currency', text: 'Currency', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter(),
                },
                {
                    dataField: 'POAmount', text: 'PO Amount', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter(),
                },
                {
                    dataField: 'Location', text: 'Location', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter(),
                },
                {
                    dataField: 'PO Creation Date', text: 'PO Creation Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter(),
                },
                {
                    dataField: 'Stat. Delivery Date', text: 'Stat. Delivery Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Status', text: 'Status', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },

            )
            await this.props.poDetails.excelData[0].map(async (data, Index) => {
                let Projectcode = data.ProjectCode ? data.ProjectCode.includes('ET') ? (data.ProjectCode).slice(0, 11) : (data.ProjectCode).slice(0, 6) : 'Other'
                await csvData.push({
                    "Id": Index + 1,
                    "POSAPId": data.POSAPId,
                    "ProjectCode": Projectcode,
                    "PlantCode": data.PlantCode ? data.PlantCode : 'NA',
                    "PurchaseGroup": data.PurchaseGroup ? data.PurchaseGroup : 'NA',
                    "VendorSapId": data.VendorSapId ? data.VendorSapId : 'NA',
                    "VendorName": data.VendorName ? data.VendorName : 'NA',
                    "PaymentTermCode": data.PaymentTermCode ? data.PaymentTermCode : 'Payment Term Not Linked',
                    "Currency": data.Currency ? data.Currency : 'NA',
                    "POAmount": data.POAmount ? data.POAmount : 'NA',
                    "Location": data.Location ? data.Location : 'NA',
                    "PO Creation Date": data.POCreationDate ? dateFormater(data.POCreationDate) : "NA",
                    "Stat. Delivery Date": data.PODeliveryDate ? dateFormater(data.PODeliveryDate) : "NA",
                    "Status": data.POLineItemSAPCode == null && data.PlantCode ? "PO Cancelled" : data.TrnStatusName
                })
            })
        }
        if (this.state.forModule.value === 'Expiditing') {
            await this.props.GetExcellExportData()
            columns.push(
                {
                    dataField: 'Id', text: 'Id', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '50px', textAlign: 'center' };
                    }, hidden: true, filter: textFilter()
                },
                {
                    dataField: 'Expeditor', text: 'Expeditor', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'PlantCode', text: 'PlantCode', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'WBSCode', text: 'WBSCode', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Expeditor', text: 'Expeditor', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, hidden: true, filter: textFilter()
                },
                {
                    dataField: 'VendorSapId', text: 'VendorSapId', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'VendorName', text: 'Vendor Name', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'POSAPId', text: 'POSAPId', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'POLineItemSAPCode', text: 'POLineItemSAPCode', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'PO Doc. Date', text: 'PO Doc. Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'PO Uploaded On', text: 'PO Uploaded On', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'PO Approved On', text: 'PO Approved On', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                // { dataField: 'Stat. Delivery Date', text: 'Stat. Delivery Date', sort: true, filter: textFilter()
                {
                    dataField: 'Status', text: 'PO Status', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Item Description', text: 'Item Description', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Qty', text: 'Qty', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                // {
                //     dataField: 'Drg. Status', text: 'Drg. Status', sort: true, filter: textFilter()
                // },
                {
                    dataField: 'Drg. Approved Date', text: 'Drg. Approved Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Statistical Delivery Date', text: 'Statistical Delivery Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'IC Offered', text: 'IC Offered', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'IC Cleared', text: 'IC Cleared', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'IC Clear Date', text: 'IC Clear Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Customer IC Date', text: 'Customer IC Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'DC Qty', text: 'DC Qty', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'DC No', text: 'DC No', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'DC Clr. Date', text: 'DC Clr. Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Delivered Qty', text: 'Delivered Qty', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Balance Qty', text: 'Balance Qty', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'PO Delivery Date', text: 'PO Delivery Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                // {
                //     dataField: 'Expected Delivery Date', text: 'Expected Delivery Date', sort: true, filter: textFilter()
                // },
                // {
                //     dataField: 'PI Date', text: 'PI Date', sort: true, filter: textFilter()
                // },
                // {
                //     dataField: "Payment Date", text: "Payment Date", sort: true, filter: textFilter()
                // },
                {
                    dataField: 'Location', text: 'Vendor Location', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: "IncoTerms", text: 'IncoTerms', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'PaymentTerm', text: 'Payment Term', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Currency', text: 'Currency', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Net Price', text: 'Net Price', sort: true, filter: textFilter()
                },
                {
                    dataField: "Net Value", text: 'Net Value', sort: true, filter: textFilter()
                },
                // {
                //     datField: "Delivered Value(INR)", text: 'Delivered Value(INR)', sort: true, filter: textFilter()
                // },
                // {
                //     dataField: "Balance Value(INR)", text: 'Balance Value(INR)', sort: true, filter: textFilter()
                // },
                {
                    dataField: "Del. Indicator", text: 'Del. Indicator', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: "GRN No.", text: 'GRN No.', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: "GRN Date", text: 'GRN Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                // {
                //     dataField: "OTD", text: 'OTD', sort: true, filter: textFilter()
                // },
                {
                    dataField: "Remarks", text: 'Remarks', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },

            )
            console.log("bn ddkjc hdcsx", await this.props.poDetails.excelData[1])
            await this.props.poDetails.excelData[1].map(async (data, Index) => {
                console.log("kjhgcvsdac", data)
                let Projectcode = data.ProjectCode ? data.ProjectCode.includes('ET') ? (data.ProjectCode).slice(0, 11) : (data.ProjectCode).slice(0, 6) : ''
                await csvData.push({
                    "Id": Index + 1,
                    "Expeditor": data.ClaimbyExpeditorName ? data.ClaimbyExpeditorName : 'To Be Claimed',
                    "PlantCode": data.PlantCode,
                    "POSAPId": data.POSAPId,
                    "WBSCode": data.WBSCode,
                    "VendorSapId": data.VendorSapId,
                    "VendorName": data.VendorName,
                    "Location": data.VendorCountry && data.VendorState ? `${data.VendorCountry} / ${data.VendorState}` : "---",
                    "PaymentTerm": data.PaymentTermCode ? data.PaymentTermCode : "---",
                    "Currency": data.Currency ? data.Currency : "---",
                    "POAmount": data.POAmount,
                    "POLineItemSAPCode": data.POLineItemSAPCode,
                    "Net Price": data.NetPrice ? data.NetPrice : "---",
                    "Net Value": data.NetValue ? data.NetValue : "---",
                    "PO Doc. Date": data.POCreationDate ? dateFormater(data.POCreationDate) : "--- ",
                    "PO Uploaded On": data.RequestedDate ? dateFormater(data.RequestedDate) : "--- ",
                    "PO Approved On": data.PoApprovalDate ? dateFormater(data.PoApprovalDate) : "---",
                    "Status": data.POLineItemSAPCode == null && data.PlantCode ? "PO Cancelled" : data.TrnStatusName,
                    "Item Description": data.POLineItemDescription,
                    "Qty": data.POLineItemQuantity,
                    // "Drg. Status": data.DrawingStatus ? data.CountAssignment !== 0 ? "Document " + data.DocumentName + " " + this.state.docStatus1[data.DrawingStatus].title + " by " + data.approvedByName
                    //                 : "Document " + data.DocumentName + " " + this.state.docStatus[data.DrawingStatus].title + " by " + data.approvedByName : " ",
                    "Drg. Approved Date": data.DrawingActionDate ? dateFormater(data.DrawingActionDate) : " ---",
                    "Statistical Delivery Date": data.StatDeliveryDate ? dateFormater(data.StatDeliveryDate) : "---",
                    "IC Offered": data.OfferedQuantity ? data.OfferedQuantity : 0,
                    "IC Cleared": data.AcceptedQuantity ? data.AcceptedQuantity : 0,
                    "IC Clear Date": data.InspectionRequestedDate ? dateFormater(data.InspectionRequestedDate) : "---",
                    "Customer IC Date": data.CustomerICDate ? formatedDate(data.CustomerICDate) : "---",
                    "DC Qty": data.DispatchQuantity ? data.DispatchQuantity : "---",
                    "DC No": data.DCNo ? "DC-" + data.DCNo : "---",
                    "DC Clr. Date": data.DCIssuedDate ? dateFormater(data.DCIssuedDate) : "---",
                    "Delivered Qty": data.POLineItemTotalDeliveredQuantity ? data.POLineItemTotalDeliveredQuantity : 0,
                    "Balance Qty": data.POLineItemTotalDeliveredQuantity ? data.POLineItemTotalDeliveredQuantity : 0,
                    "PO Delivery Date": data.PODeliveryDate ? dateFormater(data.PODeliveryDate) : "---",
                    // "Expected Delivery Date": '',
                    // "PI Date": '',
                    // "Payment Date": '',
                    "IncoTerms": data.incoTerms ? data.incoTerms : "---",
                    "PO Creation Date": data.POCreationDate ? dateFormater(data.POCreationDate) : "---",
                    "Stat. Delivery Date": data.PODeliveryDate ? dateFormater(data.PODeliveryDate) : "---",
                    // "Delivered Value(INR)": '',
                    // "Balance Value(INR)": '',
                    "Del. Indicator": data.DeletionIndicator ? data.DeletionIndicator : "---",
                    "GRN No.": data.GRNDocNo ? data.GRNDocNo : "---",
                    "GRN Date": data.GRNDocDt ? dateFormater(data.GRNDocDt) : "---",
                    // "OTD": '',
                    "Remarks": data.Remarks ? data.Remarks : "---",
                })
            })
        }
        if (this.state.forModule.value === 'QA Planner') {
            // let searchData = {
            //     poStatus: 7,
            //     sortByEmployees: this.state.sortByEmployees,
            //     sortByPlantCode: this.state.sortByPlantCode,
            //     sortByWBS: this.state.sortByWBS,
            //     sortByPo: this.state.sortByPo,
            //     sortByVendor: this.state.sortByVendor,
            //     sortBySupplierCategory: this.state.sortBySupplierCategory,
            //     sortBy: this.state.sortBy,
            //     poDocStartDate: this.state.poDocStartDate,
            //     poDocEndDate: this.state.poDocEndDate,
            // }
            // await this.props.getPOSearch(searchData)
            await this.props.GetExcellExportData()
            columns.push(
                {
                    dataField: 'Id', text: 'Id', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '50px', textAlign: 'center' };
                    }, hidden: true, filter: textFilter()
                },
                {
                    dataField: 'POSAPId', text: 'POSAPId', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'ProjectCode', text: 'ProjectCode', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'VendorSapId', text: 'VendorSapId', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'VendorName', text: 'Vendor Name', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'PO Date', text: 'PO Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'PO Del. Date', text: 'PO Del. Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'PO Approved Date', text: 'PO Approved Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Location', text: 'Location', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Hold', text: 'Hold', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Claimed By', text: 'Claimed By', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Claimed Date', text: 'Claimed Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Vendor Category', text: 'Vendor Category', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Currency', text: 'Currency', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'PO Amount', text: 'PO Amount', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Plant Code', text: 'Plant Code', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'PurchaseGroup', text: 'PurchaseGroup', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },

            )
            console.log("podetails is posearch------->", await this.props.poDetails.excelData)
            await this.props.poDetails.excelData[2].map(async (data, index) => {
                let Projectcode = data.ProjectCode ? data.ProjectCode.includes('ET') ? (data.ProjectCode).slice(0, 11) : (data.ProjectCode).slice(0, 6) : ''
                await csvData.push({
                    "Id": index + 1,
                    "POSAPId": data.POSAPId,
                    "ProjectCode": Projectcode,
                    "VendorSapId": data.VendorSapId,
                    "VendorName": data.VendorName,
                    "PO Date": data.POCreationDate ? dateFormater(data.POCreationDate) : '---',
                    "PO Del. Date": data.PODeliveryDate ? dateFormater(data.PODeliveryDate) : '---',
                    "PO Approved Date": data.PoApprovalDate ? dateFormater(data.PoApprovalDate) : '---',
                    "Location": data.Location,
                    "Hold": data.status ? data.status : '---',
                    "Claimed By": data.Claimby,
                    "Claimed Date": data.ClaimedDate ? dateFormater(data.ClaimedDate) : '---',
                    "Vendor Category": data.SupplierCategory,
                    "Currency": data.Currency,
                    "PO Amount": data.POAmount,
                    "Plant Code": data.PlantCode,
                    "PurchaseGroup": data.PurchaseGroup,
                })
            })
        }
        if (this.state.forModule.value === 'Dispatch') {
            var roles = AuthHandler.getRoles()
            console.log("roles is ------------>", roles)

            let searchdata = {
                userId: 0,
                filterByPOSAPId: this.state.filterByPOSAPId,
                filterByVendorName: this.state.filterByVendorName,
            }
            await this.props.GetPOAndLineItemListForDispatch(searchdata)
            await this.props.GetPOAndLineItemListForDispatchForDCListing(searchdata)

            columns.push(
                {
                    dataField: 'Id', text: 'Id', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '50px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'PO No', text: 'PO No', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: "PO Line Item No", text: "PO Line Item No", sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: "Issued qty", text: "Issued qty", sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: "Qty Already Dispatched", text: "Qty Already Dispatched", sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: "Customer BillingSchedule No.", text: "Customer BillingSchedule No.", sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: "Customer BillingSchedule Description", text: "Customer BillingSchedule Description", sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                }

            )
            console.log("props.dispatchorde------------>", this.props.dispatchOrderDetailsReducer.getPOAndLineItemDetails.recordsets)
            let tabledata = await this.props.dispatchOrderDetailsReducer.getPOAndLineItemListForDispatchForDCListing.recordset.filter((data) => data.Issued == 2)
            await tabledata.map((data, index) => {
                // let Projectcode = data.ProjectCode ? data.ProjectCode.includes('ET') ? (data.ProjectCode).slice(0, 11) : (data.ProjectCode).slice(0, 6) : ''
                csvData.push({
                    "Id": index + 1,
                    "PO No": data.POSAPId,
                    "PO Line Item No": data.POLineItemSAPCode,
                    "Issued qty": data.IssuedQunatity,
                    "Qty Already Dispatched": data.AlreadyDispatched,
                    "Customer BillingSchedule No.": data.BillingScheduleNo,
                    "Customer BillingSchedule Description": data.BillScheduleDescription,
                })
            })
        }
        if (this.state.forModule.value === 'Invoice') {
            this.setState({
                loading: true
            });
            var UserId = authInstance.getUserID()
            var role = authInstance.getRoles()
            let searchData = {
                currentPage: 1,
                posPerpage: 100000000000000,
                searchTerm: '',
                searchFor: '',
                UserId: role[5] ? UserId : 0
            }
            await this.props.GetAllInvoicesForSupplier(searchData)
            columns.push(
                {
                    dataField: 'Id', text: 'Id', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '50px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Vendor Name', text: 'Vendor Name', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Plant Code', text: 'Plant Code', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Project Code', text: 'Project Code', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'PO No', text: 'PO No', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Invoice No', text: 'Invoice No', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Invoice Date', text: 'Invoice Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Due Date', text: 'Due Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Invoice Amount(INR)', text: 'Invoice Amount(INR)', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Net Payable', text: 'Net Payable', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Paid Amount', text: 'Paid Amount', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Final Approval', text: 'Final Approval', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Payment Date', text: 'Payment Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Invoice Type', text: 'Invoice Type', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Vendor Type', text: 'Vendor Type', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Invoice Amount', text: 'Invoice Amount', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Invoie Submmision Date', text: 'Invoie Submmision Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'CM Approval Applicable', text: 'CM Approval Applicable', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'CM Approval Date', text: 'CM Approval Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'PM Approval Applicable', text: 'PM Approval Applicable', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'PM Approval Date', text: 'PM Approval Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'AP team Approval Applicable', text: 'AP team Approval Applicable', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'AP team Approval Date', text: 'AP team Approval Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Expediter Approval Applicable', text: 'Expediter Approval Applicable', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Expediter Approval Date', text: 'Expediter Approval Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'QA Approval Applicable', text: 'QA Approval Applicable', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'QA Approval Date', text: 'QA Approval Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Treasury Approval Applicable', text: 'Treasury Approval Applicable', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Treasury Approval Date', text: 'Treasury Approval Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Advance Deduction', text: 'Advance Deduction', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Retention Deduction', text: 'Retention Deduction', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'LD Deduction', text: 'LD Deduction', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'TDS Deduction', text: 'TDS Deduction', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Others Deduction', text: 'Others Deduction', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Reason For Others', text: 'Reason For Others', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Vendor Address', text: 'Vendor Address', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Vendor GSTIn', text: 'Vendor GSTIn', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Utr No', text: 'Utr No', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'SAP Doc no', text: 'SAP Doc no', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'SAP Doc Date', text: 'SAP Doc Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Payment Method', text: 'Payment Method', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Status', text: 'Status', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
            )
            console.log("this.props.Invoices.ge------------->", this.props.invoices.getAllInvoicesforSupplier.recordset)
            let invoiceTableData = await this.props.invoices.getAllInvoicesforSupplier.recordset.filter(data => data.InvoiceDocId != null && data.approvalStatus !== null && data.approvalStatus !== 0)
            for (let i = 0; i < invoiceTableData.length; i++) {
                const data = invoiceTableData[i];
                let Projectcode = data.ProjectCode ? data.ProjectCode.includes('ET') ? (data.ProjectCode).slice(0, 11) : (data.ProjectCode).slice(0, 6) : ''
                await csvData.push({
                    "Id": i + 1,
                    "Vendor Name": data.VendorName,
                    "Plant Code": data.PlantCode,
                    "Project Code": Projectcode,
                    "PO No": data.POSAPId,
                    "Invoice No": data.InvoiceNo,
                    "Invoice Date": data.InvoiceDate ? dateFormater(data.InvoiceDate) : "",
                    "Due Date": data.DueDate ? dateFormater(data.DueDate) : "",
                    "Invoice Amount(INR)": data.InvoiceAmountinINR ? numberWithCommas(data.InvoiceAmountinINR) : "",
                    "Invoie Submmision Date": data.InvoiceSubmittedOn ? dateFormater(data.InvoiceSubmittedOn) : "",
                    "CM Approval Applicable": data.CMApprovalRequired,
                    "CM Approval Date": data.CMApprovedDate ? dateFormater(data.CMApprovedDate): "",
                    "PM Approval Applicable": data.PMApprovalRequired,
                    "PM Approval Date": data.PMApprovedDate ? dateFormater(data.PMApprovedDate): "",
                    "AP team Approval Applicable": data.APTeamApprovalRequired,
                    "AP team Approval Date": data.APTeamApprovedDate ? dateFormater(data.APTeamApprovedDate): "",
                    "Expediter Approval Applicable": data.EXApprovalRequired,
                    "Expediter Approval Date": data.EXApprovedDate ? dateFormater(data.EXApprovedDate): "",
                    "QA Approval Applicable": data.QAApprovalRequired,
                    "QA Approval Date": data.QAApprovedDate ? dateFormater(data.QAApprovedDate): "",
                    "Treasury Approval Applicable": data.TreasuryApprovalRequired,
                    "Treasury Approval Date": data.TreasuryApprovedDate ? dateFormater(data.TreasuryApprovedDate): "",
                    "Net Payable": data.NetPayableAmount ? numberWithCommas(data.NetPayableAmount) : "",
                    "Paid Amount": data.TotalPaidAmount ? numberWithCommas(data.TotalPaidAmount) : "0",
                    "Final Approval": data.ApprovalDate ? dateFormater(data.ApprovalDate) : "",
                    "Payment Date": data.paymentDate ? dateFormater(data.paymentDate) : "",
                    "Invoice Type": data.TypeFor ? data.InvoiceTypeName + ' against ' + data.TypeFor : data.InvoiceTypeName,
                    "Vendor Type": data.SSIType == "" ? "NON MSME" : "MSME",
                    "Invoice Amount": data.CurrencyType + ' ' + numberWithCommas(data.InvoiceAmount),
                    "Advance Deduction": data.CurrencyType + ' ' + (data.AdvanceDeduction && data.AdvanceDeduction != null ? numberWithCommas(data.AdvanceDeduction) : '0.00'),
                    "Retention Deduction": data.CurrencyType + ' ' + (data.RetentionDeduction && data.RetentionDeduction != null ? numberWithCommas(data.RetentionDeduction) : '0.00'),
                    "LD Deduction": data.CurrencyType + ' ' + (data.LDDeduction && data.LDDeduction != null ? numberWithCommas(data.LDDeduction) : '0.00'),
                    "TDS Deduction": data.CurrencyType + ' ' + (data.TDSDeduction && data.TDSDeduction != null ? numberWithCommas(data.TDSDeduction) : '0.00'),
                    "Others Deduction": data.CurrencyType + ' ' + (data.OthersDeduction && data.OthersDeduction != null ? numberWithCommas(data.OthersDeduction) : '0.00'),
                    "Reason For Others": data.ReasonForOthersDeduction ? data.ReasonForOthersDeduction : '',
                    "Vendor Address": data.VendorAddress + ',' + data.VendorAddress1 + ',' + data.VendorAddress2,
                    "Vendor GSTIn": data.VendorGstin,
                    "Utr No": data.utrNo,
                    "SAP Doc no": data.SAPDocNo,
                    "SAP Doc Date": data.SAPDocDate ? dateFormater(data.SAPDocDate) : '',
                    "Payment Method": data.PaymentMediumName,
                    "Status": data.InvoiceStatusName,
                })
            }
        }
        if (this.state.forModule.value === 'Inspection QA Planner') {
            let callsData = []
            var roles = AuthHandlerInstance.getRoles()
            var userId = AuthHandlerInstance.getUserID()
            let searchData = {
                sortbyPo: this.state.sortbyPo,
                vendor: this.state.vendor,
                inspectionLocation: this.state.inspectionLocation,
                status: this.state.status,
                searchTerm: this.state.searchTerm,
                searchFor: this.state.searchFor
            }
            await this.props.getInspectionDetailsByInspectorID(0, searchData)
            columns.push(
                {
                    dataField: 'Id', text: 'Id', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '50px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'callsData', text: 'callsData', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Vendor', text: 'Vendor', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'WBS NO', text: 'WBS NO', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'PO Number', text: 'PO Number', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Line Item No', text: 'Line Item No', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Item Description', text: 'Item Description', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Requested Date', text: 'Requested Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Inspection Location', text: 'Inspection Location', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Inspection Date', text: 'Inspection Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Status', text: 'Status', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Location', text: 'Location', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Planner action date', text: 'Planner action date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Waiveoff Date', text: 'Waiveoff Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'QAPlanner Name', text: 'QAPlanner Name', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Inspector', text: 'Inspector', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Rejection Reason', text: 'Rejection Reason', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Next Planned Date', text: 'Next Planned Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'DC Generated Date', text: 'DC Generated Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
            )
            if (this.props.inspectionReducer && this.props.inspectionReducer.inspectionDetailsByInspectorId) {
                let data = await this.props.inspectionReducer.inspectionDetailsByInspectorId
                for (let i = 0; i < data.length; i++) {
                    await callsData.push(data[i])
                }
            }
            console.log("lkjhgfdxcvbn dws", callsData)
            await callsData.map(async (data, index) => {
                let Projectcode = data.WBSCode ? data.WBSCode.includes('ET') ? (data.WBSCode).slice(0, 11) : (data.WBSCode).slice(0, 6) : ''
                // let dayDiff=[]
                // if (data.InspectionSDate !== null && data.DcIssuedDate !== null) {
                //     const startDate = new Date(data.InspectionSDate);
                //     const endDate = new Date(data.DcIssuedDate);
                //     const timeDiff = endDate.getTime() - startDate.getTime();
                //     dayDiff = Math.floor(timeDiff / (1000 * 3600 * 24));
                //     console.log(dayDiff); // or return dayDiff if you want to use it elsewhere
                //   }
                await csvData.push({
                    "Id": index + 1,
                    "callsData": data.callId,
                    "Vendor": data.vendorName,
                    "WBS NO": Projectcode,
                    "PO Number": data.poNo,
                    "Line Item No": data.poLineItemNo,
                    "Item Description": data.lineItemDescription,
                    "Requested Date": dateFormater(data.proposedDate),
                    "Inspection Location": data.InspectionLocation ? data.InspectionLocation : "---",
                    "Inspection Date": data.InspectionDate ? dateFormater(data.InspectionDate) : "---",
                    "Status": data.HasWaivedOff ? 'Inspection has waived off' : data.CallItemType == 'RW' && !data.InspectionStatus ? 'Rework Call' : !data.InspectionStatus ? 'New Call' : data.InspectionStatus,
                    "Location": data.location,
                    "Planner action date": data.InspectionStatusLog !== null && data.InspectionStatusLog === 'Inspector Allocated' ? dateFormater(data.InspectionSDate) : '---',
                    "Waiveoff Date": data.InspectionSDate && data.HasWaivedOff === 1 ? dateFormater(data.InspectionSDate) : '---',
                    "QAPlanner Name": data.InspectionActionUser !== null && ((data.HasWaivedOff === 1 && data.LineItemstatus === data.InspectionStatusLog) || (data.HasWaivedOff === null && data.InspectionStatus === data.InspectionStatusLog) || (data.HasWaivedOff === 1 && data.InspectionStatus === data.InspectionStatusLog)) ? data.InspectionActionUser : '---',
                    "Inspector": data.InspectorName ? data.InspectorName : '--',
                    "Rejection Reason": data.RejectionReason ? data.RejectionReason : '--',
                    "Next Planned Date": data.NextPlannedDate ? dateFormater(data.NextPlannedDate) : '--',
                    "DC Generated Date": data.InspectionSDate !== null && data.DcIssuedDate !== NaN && data.InspectionStatusLog !== 'Inspection Request Accepted' && data.InspectionStatusLog !== 'Inspection Request Rejected' && data.InspectionStatusLog !== 'Inspector Re-Allocated' && data.InspectionStatusLog !== 'Inspection has waived off' ? dateFormater(data.DcIssuedDate) : '---'
                })
            })
        }
        if (this.state.forModule.value === 'Inspection Inspector') {
            var roles = AuthHandlerInstance.getRoles()
            var userId = AuthHandlerInstance.getUserID()
            let inspectionData = []
            let searchData = {
                sortbyPo: this.state.sortbyPo,
                vendor: this.state.vendor,
                inspectionLocation: this.state.inspectionLocation,
                status: this.state.status,
                searchTerm: this.state.searchTerm,
                searchFor: this.state.searchFor
            }
            await this.props.getInspectionDetailsByInspectorID()
            columns.push(
                {
                    dataField: 'Id', text: 'Id', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '50px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Inspection ID', text: 'Inspection ID', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Vendor', text: 'Vendor', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'PO Number', text: 'PO Number', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Inspection Date', text: 'Inspection Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Location', text: 'Location', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Status', text: 'Status', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'PO Date', text: 'PO Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'pending request', text: 'pending request', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'PO Date', text: 'PO Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter(),
                },
                {
                    dataField: 'Inspection Raised Date', text: 'Inspection Raised Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'call acceptance date', text: 'call acceptance date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter(), headerStyle: (column, colIndex) => { return { width: '7rem' } }
                },
                {
                    dataField: 'QAPlanner Name', text: 'QAPlanner Name', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter(), headerStyle: (column, colIndex) => { return { width: '7rem' } }
                },
                {
                    dataField: 'inspection report date', text: 'inspection report date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter(), headerStyle: (column, colIndex) => { return { width: '7rem' } }
                },
                {
                    dataField: 'DC Generated Date', text: 'DC Generated Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'CSMTLink', text: 'CSMTLink', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter(), headerStyle: (column, colIndex) => { return { width: '7rem' } }
                },
            )
            if (this.props.inspectionReducer && this.props.inspectionReducer.inspectionDetailsByInspectorId) {
                let insdata = await this.props.inspectionReducer.inspectionDetailsByInspectorId
                for (let i = 0; i < insdata.length; i++) {
                    await inspectionData.push(insdata[i])
                }
            }
            console.log(";lkuhjgfdcvbnkred", inspectionData)
            await inspectionData.map(async (data, index) => {
                let Projectcode = data.ProjectCode ? data.ProjectCode.includes('ET') ? (data.ProjectCode).slice(0, 11) : (data.ProjectCode).slice(0, 6) : ''
                await csvData.push({
                    "Id": index + 1,
                    "Inspection ID": data.InspectionId,
                    "Vendor": data.vendorName,
                    "PO Number": data.poNo,
                    "Inspection Date": dateFormater(data.InspectionStartDate),
                    "Location": data.location,
                    "Status": data.InspectionStatus,
                    "Location": data.location,
                    "pending request": data.InspectionStatus !== 'Inspection Request Accepted' && data.InspectionStatus !== 'Inspection Request Rejected' && data.InspectionStatus !== 'Inspector Re-Allocated' ? data.InspectionStatus : !data.InspectionStatus ? 'New Call' : '---',
                    "PO Date": dateFormater(data.createdOn),
                    "Inspection Raised Date": dateFormater(data.InspectionRaisedDate),
                    "call acceptance date": data.InspectionStatus === "Inspection Request Rejected" && data.NextPlannedDate !== null ? dateFormater(data.NextPlannedDate) : data.InspectionStatus === "Inspection Request Accepted" ? dateFormater(data.InspectionStartDate) : '----',
                    "QAPlanner Name": data.InspectionActionUser !== null && ((data.HasWaivedOff === 1 && data.LineItemstatus === data.InspectionStatusLog) || (data.HasWaivedOff === null && data.InspectionStatus === data.InspectionStatusLog) || (data.HasWaivedOff === 1 && data.InspectionStatus === data.InspectionStatusLog) || (data.HasWaivedOff === null && data.LineItemstatus === data.InspectionStatusLog)) ? data.InspectionActionUser : '---',
                    "inspection report date": data.LineItemstatus === 'Closed and Accepted' || data.LineItemstatus === data.InspectionStatusLog ? timeFormater(data.InspectionSDate) : '---',
                    "DC Generated Date": data.InspectionSDate !== null && data.DcIssuedDate !== NaN && data.InspectionStatusLog !== 'Inspection Request Accepted' && data.InspectionStatusLog !== 'Inspection Request Rejected' && data.InspectionStatusLog !== 'Inspector Re-Allocated' && data.InspectionStatusLog !== 'Inspection has waived off' ? dateFormater(data.DcIssuedDate) : '---',
                    'CSMTLink': data.CSMTLink !== null && data.InspectionStatusLog === data.LineItemstatus && data.LineItemstatus === "Inspection has waived off" ? timeFormater(data.CSMTUPDATEDDATE) : (data.LineItemstatus === 'Closed and Accepted' && data.CSMTLink !== null) ? timeFormater(data.CSMTUPDATEDDATE) : '---'
                })
            })
        }
        if (this.state.forModule.value === 'BG List') {
            await this.props.getBGListDetails() // api to get the data regarding BG list
            columns.push(
                {
                    dataField: 'Id', text: 'Id', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '50px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Doc. Date', text: 'Doc. Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Posting Date', text: 'Posting Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'BG Type', text: 'BG Type', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Guarantee No.', text: 'Guarantee No.', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Currency', text: 'Currency', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Spl G/L indicator', text: 'Spl G/L indicator', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Business Area', text: 'Business Area', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Entity Name', text: 'Entity Name', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'BG Amount', text: 'BG Amount', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Old BG no.', text: 'Old BG no.', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Vendor Code', text: 'Vendor Code', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Expiry date', text: 'Expiry date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Purchase order no', text: 'Purchase order no', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Claim Date', text: 'Claim Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Bank Name', text: 'Bank Name', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Branch Email', text: 'Branch Email', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Address 1', text: 'Address 1', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Address 2', text: 'Address 2', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'City', text: 'City', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Pincode', text: 'Pincode', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Country', text: 'Country', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Supplier Name', text: 'Supplier Name', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'BG Confirmation Remarks', text: 'BG Confirmation Remarks', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },

            )
            let tableData = await this.props.expediting.bgDetails.recordset // to store the fetched data through api into variable
            await tableData.map((data, index) => {
                csvData.push({
                    "Id": index + 1,
                    "Doc. Date": dateFormater(data.Document_Date),
                    "Posting Date": data.approvedOn,
                    "BG Type": data.BGType,
                    "Guarantee No.": data.Gurantee_No,
                    "Currency": data.Currency,
                    "Spl G/L indicator": data.Spl_GL_Indicator,
                    "Business Area": data.Bussiness_Area,
                    "Entity Name": data.EntityName,
                    "BG Amount": numberWithCommas(data.BG_Amount),
                    "Old BG no.": data.OLDBG_No,
                    "Vendor Code": data.VendorSAPId,
                    "Expiry date": dateFormater(data.Expiry_Date),
                    "Purchase order no": data.PurchaseOrderNo,
                    "Claim Date": dateFormater(data.Claim_Date),
                    "Bank Name": data.Bank_Name,
                    "Branch Email": data.Branch_Email,
                    "Address 1": data.Address_1,
                    "Address 2": data.Address_2,
                    "City": data.City,
                    "Pincode": data.PinCode,
                    "Country": data.Country,
                    "Supplier Name": data.SupplierName,
                    "BG Confirmation Remarks": data.BGConfirmationRemarks,
                })
            })
        }
        if (this.state.forModule.value === 'GRNDataList') {
            await this.props.GetGRNExport()
            columns.push(
                {
                    dataField: 'Id', text: 'Id', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '50px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'PO Number', text: 'PO Number', filter: textFilter()
                },
                {
                    dataField: 'POLineItemSAPCode', text: 'POLineItemSAPCode', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'SRN', text: 'SRN', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'GRN DocNO', text: 'GRN DocNO', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'GRN DocYear', text: 'GRN DocYear', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'GRN ItemNo', text: 'GRN ItemNo', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'GRN DocDt', text: 'GRN DocDt', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'GRN PostingDt', text: 'GRN PostingDt', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'GRNUOM', text: 'GRNUOM', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'GRNCreation Date', text: 'GRNCreation Date', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'GRNBillofLadding', text: 'GRNBillofLadding', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'CounGRNDocHeader Textry', text: 'CounGRNDocHeader Textry', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'GRN Plant', text: 'GRN Plant', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'GRN CreatedBy', text: 'GRN CreatedBy', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'Created On', text: 'Created On', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
                {
                    dataField: 'ServiceLineItem No', text: 'ServiceLineItem No', sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '200px', textAlign: 'center' };
                    }, filter: textFilter()
                },
            )
            let tableData = await this.props.poDetails.getGRNDetailsExport
            await tableData.map((data, index) => {
                csvData.push({
                    "Id": index + 1,
                    "PO Number": data.POSAPId,
                    "POLineItemSAPCode": data.POLineItemSAPCode,
                    "SRN": data.SRN,
                    "GRN DocNO": data.GRNDocNo,
                    "GRN DocYear": data.GRNDocYear,
                    "GRN ItemNo": data.GRNItemNo,
                    "GRN DocDt": data.GRNDocDt ? formatDate(data.GRNDocDt) : '-',
                    "GRN PostingDt": data.GRNPostingDt ? formatDate(data.GRNPostingDt) : '-',
                    "GRNUOM": data.GRNQty + " " + data.GRNUOM,
                    "GRNCreation Date": data.GRNCreationDate ? formatDate(data.GRNCreationDate) : '',
                    "GRNBillofLadding": data.GRNBillofLadding,
                    "GRNDocHeader Text": data.GRNDocHeaderText,
                    "GRN Plant": data.GRNPlant,
                    "GRN CreatedBy": data.GRNCreatedBy,
                    "Created On": data.CreatedOn ? formatDate(data.CreatedOn) : '-',
                    "ServiceLineItem No": data.ServiceLineItemNumber
                })

            })
        }
        await this.setState({ csvData, columns, loading: false })
        console.log("download button press :", input)
    }
    settrue = (e) => {
        let forModule = e
        this.setState({
            forModule
        })
    }
    render() {
        const customStyles = {
            option: (provided, state) => ({
                ...provided,
                borderBottom: '1px dotted pink',
                //   color: state.isSelected ? 'red' : 'blue',
                padding: "2px 10px",
            }),
            menu: (provided, state) => ({
                ...provided,
                width: "100%",
                minWidth: "max-content",
                zIndex: "999 !important",
            }),
        }
        const options = [
            { value: "Purchase Orders", label: "Purchase Orders" },
            { value: "QA Planner", label: "QA Planner" },
            { value: "Expiditing", label: "Expiditing" },
            { value: "Dispatch", label: "Dispatch" },
            { value: "Invoice", label: "Invoice" },
            { value: "Inspection QA Planner", label: "Inspection QA Planner" },
            { value: "Inspection Inspector", label: "Inspection Inspector" },
            { value: "BG List", label: "BG List" },
            { value: "GRNDataList", label: "GRNDataList" }
        ]
        const defaultSorted = [{
            dataField: 'PO Creation Date',
            order: 'desc'
        }];
        const pagination = paginationFactory({
            page: 1,
            sizePerPage: 50,
            lastPageText: '>>',
            firstPageText: '<<',
            nextPageText: '>',
            prePageText: '<',
            showTotal: true,
            alwaysShowAllBtns: true,
            onPageChange: function (page, sizePerPage) {
                console.log('page', page);
                console.log('sizePerPage', sizePerPage);
            },
            onSizePerPageChange: function (page, sizePerPage) {
                console.log('page', page);
                console.log('sizePerPage', sizePerPage);
            }
        });
        const { SearchBar, ClearSearchButton } = Search;
        const MyExportCSV = (props) => {
            const handleClick = () => {
                props.onExport();
            };
            return (
                <div>
                    <Button className="float-right align-middle" variant='success' onClick={handleClick}><FontAwesomeIcon className='mr-1' icon={"file-excel"} />Download <FontAwesomeIcon className='ml-1' icon={faDownload} /></Button>
                </div>
            );
        };
        return (
            <div style={{ background: "#1e3e60", height: "93vh" }} >
                <div className="Container-fluid p-4" style={{ background: "#1e3e60" }}>
                    <div className="pt-2 m-2">
                        <div className="row justify-content-between">
                            <div className="col-5 header text-white">
                                <b>Reports Extraction</b>
                            </div>
                        </div>

                        <div className='shadow-lg p-3 mb-5 bg-white rounded' style={{ border: "4px solid white", padding: "14px", height: "100px", borderRadius: '5px', marginRight: 'auto' }}>
                            <div className='row' style={{ display: 'flex', justifyContent: 'flex-end' }}><span style={{ color: 'red', fontSize: 'small', marginTop: '-20px', marginBottom: '15px' }}>*Please select specific modules to generate the excel dump</span></div>
                            <div className='row'>
                                <div className='col-1.5 mb-2 text-muted'><b>Modules :</b></div>
                                <div className='col mb-2 text-muted'><span style={{ width: "19rem" }}><Select options={options} onChange={(e) => this.settrue(e)} /></span></div>
                                <div className='col mb-2 text-muted'><Button type="submit" disabled={this.state.forModule.length !== 0 ? false : true} onClick={this.consoledata} style={{ width: "56.5vh", borderRadius: "6px", cursor: this.state.forModule.length !== 0 ? 'pointer' : 'not-allowed', height: '36px' }}>Load Data</Button></div>
                            </div>
                        </div>
                    </div>
                    <div className="">
                        {this.state.loading ?
                            <div className='text-center' style={{ paddingTop: '10px' }}>
                                <div class="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                                </div>
                            </div>
                            : this.state.csvData.length > 0 ?
                                <ToolkitProvider bootstrap4 keyField='Id' data={this.state.csvData} columns={this.state.columns} search exportCSV>
                                    {props => (
                                        <div className="col shadow-lg p-3 mb-5 bg-white" style={{ marginTop: "4vh", display: "flex", flexDirection: "column" }}>
                                            <div className='float-right ' >
                                                {/* <div className='text-white mt-1 ml-2 float-right' style={{ padding: "0px", marginTop: "-2vh", background: '#007BFF' }}>
                                                        <ClearSearchButton {...props.searchProps} />
                                                </div> */}
                                                <span className='float-right'><SearchBar {...props.searchProps} /></span>
                                                <div className="float-right" style={{ marginTop: "0.3vh", marginRight: "0.6vh" }}><MyExportCSV {...props.csvProps} /></div>
                                            </div>
                                            <div className='row scrollTable shadow-lg p-3 mb-5 bg-white rounded' style={{ height: 'fit-content' }}>
                                                <BootstrapTable
                                                    classes='table9 table-exp1'
                                                    keyField='Id'
                                                    data={this.state.csvData}
                                                    columns={this.state.columns}
                                                    defaultSorted={defaultSorted}
                                                    pagination={pagination}
                                                    filter={filterFactory()}
                                                    {...props.baseProps}
                                                    striped
                                                    hover
                                                    condensed
                                                />
                                            </div>
                                        </div>
                                    )}
                                </ToolkitProvider>
                                : <span className='text-white' style={{ paddingTop: '10px', display: 'flex', justifyContent: 'center', backgroundColor: "#1e3e60" }}>No Data to Preview</span>
                        }
                    </div>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => ({ dispatchOrderDetailsReducer: state.dispatchOrderDetailsReducer, filterList: state.masterReducer.filterList, poDetails: state.poDetails, invoices: state.invoice, expediting: state.expediting, inspectionReducer: state.inspectionReducer })
export default connect(mapStateToProps, { GetFilterList, GetPOAndLineItemListForDispatch, GetPOAndLineItemListForDispatchForDCListing, getPOSearch, GetExcellExportData, GetAllInvoicesForSupplier, getBGListDetails, getInspectionDetailsByInspectorID, GetGRNExport })(ReportExtraction)